<template>
  <div class="formRightWrap display_center_ud">
    <div class="formBlock">
      <div class="login_title">
        <span>找回密码</span>
      </div>
      <div class="formWrap">
        <el-form :model="formData" :rules="formRules" ref="FindpswForm">
          <div class="inputBar">
            <el-form-item prop="phone" class="width100">
              <el-input placeholder="请输入手机号码" v-model="formData.phone"></el-input>
            </el-form-item>
          </div>
          <div class="inputBar">
            <el-form-item class="width100">
              <el-input placeholder="请输入验证码" v-model="formData.code"></el-input>
            </el-form-item>
            <div style="margin-left: 5px;">
              <a href="javascript:void(0);" v-if="!isdisabled" class="btnNormal" @click="getmsg">
                点击获取
              </a>
              <a href="javascript:void(0);" v-if="isdisabled" class="btnNormal">
                {{codeText}}
              </a>
            </div>
          </div>
        </el-form>
        <el-form :model="formData" :rules="formRules" ref="SetPswForm">
          <div class="inputBar">
            <el-form-item prop="SetPassword" class="width100">
              <el-input placeholder="请输入密码" type="password" v-model="formData.SetPassword"></el-input>
            </el-form-item>
          </div>
          <div class="inputBar">
            <el-form-item prop="SetAginPassword" class="width100">
              <el-input placeholder="请确认密码" type="password" v-model="formData.SetAginPassword"></el-input>
            </el-form-item>
          </div>
          <div class="marginBottom20">
            <a href="javascript:;" class="btnSubmit" @click="confirmclick">确认</a>
          </div>
        </el-form>
        <div class="display_between">
          <a href="javascript:;"></a>
          <a href="javascript:;" @click="$router.push({name:'login'})">立即登录</a>
        </div>
        <!-- <div class="redColor">两次密码输入不一致，请重新输入</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import validate from "../../assets/unit/validate";
export default {
  name: "getpass",
  data() {
    const VALIDATE_MOBILE_NO = (rule, value, callback) => {
      if (!validate.validateMobile(value)) {
        callback(new Error("手机号需为11位数字"));
      } else {
        callback();
      }
    };
    const VALIDATE_PASSWORD = (rule, value, callback) => {
      if (!validate.validatePassword(value)) {
        // callback(new Error('密码必须包含数字字符特殊符号且长度在6-20之前不能为连续数字'));
        callback(new Error('密码必须包含字母和数字且密码长度为6-20个字符'));
      } else {
        callback();
      }
    };
    return {
      index: 1,
      codeText: "",
      // 设置按钮是否禁用
      isdisabled: false,
      formData: {
        phone: "",
        code: "",
        SetPassword: "",
        SetAginPassword: ""
      },
      formRules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: VALIDATE_MOBILE_NO, trigger: 'blur' }
        ],
        SetPassword: [
          { validator: VALIDATE_PASSWORD, trigger: 'blur' },
          { required: true, message: "请输入密码", trigger: "blur" }
        ],
        SetAginPassword: [
          { required: true, message: "请输入密码", trigger: "blur" }
        ]
      },
    }
  },
  methods: {
    // 确认按钮
    confirmclick() {
      this.$refs.FindpswForm.validate(valid => {
        if (valid) {
          //验证,验证码是否正确
          if (this.formData.code == '') {
            this.$message({
              message: '验证码不能为空',
              type: 'warning'
            });
          } else {
            this.$refs.SetPswForm.validate(valid => {
              if (valid) {
                if (this.formData.SetAginPassword != this.formData.SetPassword) {
                  this.$message({
                    message: '两次密码不同，请确认密码',
                    type: 'warning'
                  })
                } else {
                  this.httphelper.post('api/LoginApi/UpdateUserPwd',
                    {
                      phoneNumber: this.formData.phone,
                      pwd: this.formData.SetPassword,
                      vcode: this.formData.code
                    }).then((res) => {
                      if (res.data.code == 200) {
                        this.$router.push({ name: 'getpassSuc' })
                      } else {
                        this.$message({
                          message: res.data.msg,
                          type: 'warning'
                        });
                      }
                    })
                }
              }
            })
          }
        }
      })
    },
    getmsg() {
      let time = 60;
      let i = 0;
      let that = this;
      this.$refs.FindpswForm.validate(valid => {
        if (valid) {
          //1.在60秒之内，button上倒计时60秒，并显示
          //2.向controller请求验证码，并发送到指定的手机号上面
          let set = setInterval(function () {
            that.codeText = (--time) + "秒后重发";
            i++;
            //此变量用于标识只调用一次获取验证码的函数
            if (i == 1) {
              //使获取验证码按钮不可点击
              that.isdisabled = true;
              that.getVerificationCode(set);
            }
          }, 1000);

          //60秒之后需要做的事情
          setTimeout(function () {
            //恢复获取验证码按钮可点击
            that.isdisabled = false
            that.codeText = "获取验证码";
            clearInterval(set);//清除计时器
          }, time * 1000); //60000
        }
      })
    },
    getVerificationCode: function (set) {

      //向服务器获取验证码
      this.httphelper.post('/api/VerifCodeApi/NoteVerifCode',
        {
          type: 2,
          phoneNumber: this.formData.phone
        }).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: '发送成功',
              type: 'success'
            });
          } else if (res.data.code == 231) {
            this.$message({
              message: '手机号已存在，请直接登录',
              type: 'warning'
            });
            clearInterval(set);
          } else if (res.data.code == 233) {
            this.$message({
              message: '发送失败',
              type: 'warning'
            });
            clearInterval(set)
          }
        })

    }
  }
}
</script>

<style scoped>
/* 每套全部引入 */
/* 每套页面对应的公共样式,每套页面都会引用 */
.wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
}

input {
  height: 40px;
  border: 1px solid #ddd;
  box-sizing: border-box;
  outline: none;
  padding-left: 12px;
}
.title {
  font-size: 110px;
  color: #fff;
  position: relative;
}
.title:before {
  content: "";
  display: inline-block;
  width: 60px;
  height: 5px;
  background: #ffffff;
  border-radius: 2px;
  position: absolute;
  top: -5px;
}
.titleSub {
  font-size: 40px;
  color: #fff;
  margin-bottom: 20px;
}
.english {
  font-size: 16px;
  color: #ffffff;
}
.english:after {
  content: "————";
  margin-left: 10px;
}
.english img {
  vertical-align: middle;
  margin-right: 10px;
}
.width100 {
  width: 100%;
}
.headBar {
  height: 60px;
}
.headBarRight a {
  margin-right: 30px;
}
.headBarRight a img {
  margin-right: 8px;
}
.content {
  min-width: 1300px;
  flex: 1;
  display: flex;
  flex-direction: column;
  background: url("../../assets/img/loginbg.png");
}
.formContent {
  display: flex;
  flex: 1;
}
.formRightWrap {
  /* 	width: 700px; */
}
.formBlock {
  background: #fff;
  width: 340px;
  padding-top: 40px;
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 36px;
  border-radius: 30px 0 30px 0;
  box-sizing: border-box;
  position: relative;
}
.bianjiao {
  position: absolute;
  right: 0;
  top: 0;
}
.bianjiaobtn {
  position: absolute;
  right: 40px;
  top: 13px;
  color: #0b8686;
  font-size: 12px;
  width: 76px;
  height: 22px;
  box-sizing: border-box;
  padding-left: 10px;
  line-height: 22px;
  background: url("../../assets/img/login/bianjaiobtn.png");
}
.login_title {
  border-bottom: 1px solid #ddd;
  font-size: 16px;
  margin-bottom: 30px;
}
.login_title span {
  display: inline-block;
  padding: 0 14px;
  padding-bottom: 10px;
  font-weight: bold;
  color: #0b8686;
  border-bottom: 2px solid #0b8686;
}
.login_title a {
  display: inline-block;
  padding: 0 14px;
  padding-bottom: 10px;
  font-weight: bold;
}
.login_title_active {
  color: #0b8686;
  border-bottom: 2px solid #0b8686;
}
.inputBar {
  display: flex;
  margin-bottom: 20px;
}
.btnNormal {
  display: inline-block;
  height: 40px;
  text-align: center;
  line-height: 40px;
  width: 104px;
  background: #e1e1e1;
}
.btnSubmit {
  width: 100%;
  height: 40px;
  text-align: center;
  display: inline-block;
  line-height: 40px;
  color: #fff;
  background: #0b8686;
}
.footer {
  height: 50px;
  background: rgba(255, 255, 255, 0.05);
}
.beian {
  color: #fff;
}
.footer a {
  color: #fff;
  margin-left: 30px;
}

/* 登录2 */
.successTip {
  height: 240px;
  flex-direction: column;
}

.successTipText {
  font-size: 22px;
  color: #0b8686;
  line-height: 1.6em;
}
.Erro {
  border: 1px solid red;
}
</style>
